import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ElxKeycloakService } from '../services/keycloak.service';
import { AuthRedirectService } from '../services/auth-redirect.service';

export const loginGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authTokenService = inject(ElxKeycloakService);
  const authRedirectService = inject(AuthRedirectService);

  // Wait for Keycloak initialization to complete
  if (typeof window !== 'undefined') {
    let attempts = 0;
    const maxAttempts = 200; // 20 seconds max wait (match authGuard / slow Keycloak)
    while (!(window as any).__keycloakInitCompleted && attempts < maxAttempts) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      attempts++;
    }
  }

  try {
    const isAuthenticated = await authTokenService.isLoggedIn();

    if (isAuthenticated) {
      // Check if there's a stored redirect URL
      const redirectUrl = authRedirectService.getAndClearRedirectUrl();

      if (redirectUrl && redirectUrl !== '/login') {
        router.navigateByUrl(redirectUrl);
      } else {
        // Default to domains page
        router.navigate(['/domains']);
      }

      return false;
    }

    return true;
  } catch (error) {
    return true;
  }
};
